import React, { useEffect, useRef } from "react";
import Typed from "typed.js";

const TypingAnimation = ({ data }) => {
  // Create a ref to the DOM element that will contain the typing text.
  const el = useRef(null);

  useEffect(() => {
    // Initialize Typed.js with options and attach it to the element
    const typed = new Typed(el.current, {
      strings: data
        ? data
        : [
            "A Java enthusiast, mastering the fundamentals...",
            "Crafting beautiful websites with WordPress...",
            "Designing intuitive UI/UX experiences...",
            "Building powerful frontend solutions with React...",
            "Evolving into a full-stack developer, solving complex problems!",
          ], // Updated strings to reflect your current roles and skills
          typeSpeed: 100,
          backSpeed: 30,
          backDelay: 10,
      smartBackspace: false, // Only backspace what doesn't match the next string
      loop: true, // Infinite loop of the strings
      showCursor: true, // Hide the blinking cursor
    });

    // Cleanup function to destroy the Typed instance when the component unmounts
    return () => {
      typed.destroy();
    };
  }, [data]); // Re-run the effect if the 'data' changes

  return (
    <div className="text-center text-2xl font-bold text-brand-green">
      <span ref={el}></span> {/* The element that will contain the animated text */}
    </div>
  );
};

export default TypingAnimation;
